import Skeleton, { SkeletonProps } from "@mui/material/Skeleton";

/**
 * `Skeleton` can infer `children` size.
 * We might don't want to redo the same code over like this https://mui.com/material-ui/react-skeleton/#inferring-dimensions
 * if `condition` is true, we will render skeleton following the children size. otherwise we will render `children` only
 */
const ConditionalSkeleton = ({
    condition,
    children,
    ...SkeletonProps
}: { condition: boolean; children: React.ReactNode } & SkeletonProps) => {
    if (condition) {
        return <Skeleton {...SkeletonProps}>{children}</Skeleton>;
    }

    return <>{children}</>;
};

export default ConditionalSkeleton;
